import { render, staticRenderFns } from "./LexiconDefinition.vue?vue&type=template&id=e09b1c2e&"
import script from "./LexiconDefinition.vue?vue&type=script&lang=js&"
export * from "./LexiconDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports